import React, { Component, Fragment } from 'react';

import { CloseModal } from 'modules/common/styles/main';
import Icon from './Icon';

import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const propTypes = {
  title: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  backdrop: PropTypes.bool,
  ignoreTrans: PropTypes.bool,
  dialogClassName: PropTypes.string,
  showHide: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

// const childContextTypes = {
//   closeModal: PropTypes.func.isRequired
// };

const contextTypes = {
  __: PropTypes.func
};

class ModalTriggerUI extends Component {
  constructor(props) {
    super(props);

    // console.log("Modal Trigger", this.props.showHide);
    this.state = { isOpen: this.props.showHide };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  getChildContext() {
    return { closeModal: this.closeModal };
  }

  openModal() {
    console.log("ModalTriggerUI openModal");
    this.setState({ isOpen: true });
  }

  closeModal() {
    console.log("ModalTriggerUI closeModal");
    this.setState({ isOpen: false });
  }

  renderHeader = () => {
    const { __ } = this.context;
    if (this.props.hideHeader) {
      return (
        <CloseModal onClick={this.props.closeModal}>
          <Icon icon="times" />
        </CloseModal>
      );
    }

    const { title, ignoreTrans, paddingContent } = this.props;
    return (
      // <Modal.Header closeButton>
      //   <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
      // </Modal.Header>
      <Modal.Header>
        <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
        <span onClick={() => this.closeModal()} style={{ cursor: "pointer", color: '#010101', fontSize: '25px' }} className='material-symbols-outlined'>cancel</span>
      </Modal.Header>
    );
  };

  render() {
    const {
      title,
      trigger,
      children,
      size,
      backdrop,
      ignoreTrans,
      dialogClassName,
      closeModal,
      openModal
    } = this.props;
    const { __ } = this.context;

    // add onclick event to the trigger component
    const triggerComponent = React.cloneElement(trigger, {
      onClick: () => this.openModal()
    });

    return (
      <Fragment>
        {trigger && triggerComponent}

        <Modal
          dialogClassName={dialogClassName}
          bsSize={size}
          show={this.state.isOpen}
          onHide={() => this.closeModal()}
          backdrop={backdrop}
          className={dialogClassName}
        >
          {console.log("ModalTriggerUI", this.state.isOpen)}
          {this.renderHeader()}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

ModalTriggerUI.propTypes = propTypes;
ModalTriggerUI.contextTypes = contextTypes;
// ModalTriggerUI.childContextTypes = childContextTypes;

export default ModalTriggerUI;



// WEBPACK FOOTER //
// src/modules/common/components/ModalTriggerUI.js